module.exports = __webpack_public_path__ + "static/media/desktopmonitor.08e7d63d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/app/how-can-be-used/assets/desktopmonitor.svg
// module id = 83
// module chunks = 0